import React, { Fragment } from 'react';
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Input, Label,InputGroup, Container } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import cx from "classnames";

import Common from '../Common';
import ListTable from '../../Common/ListTable';
import SubaccountDetails from './SubaccountDetails';
import aiData from "../../assets/utils/images/agent_no_records.png"
import { setSessionValue, isMobile, getSessionValue, prepareCustomTableData, getOrganizationInfo, parseJSON, checkIsAdmin, showToast, confirmBoxWithImage, handleErrorResponse, translateContent, getSubaccountCount, confirmBox, addAgentToSyncList, handelCommonChangeAgent, handleCommonRemoveAgent, getAgentByApiCommon, getEncodeData,  getKnowledgeByApiCommon, renderSelectableList, addKBToSyncList, isApiAlreadyMapped, isApiKeyValid, isPageReload, getHostPrefix,getPerRecordOption, getPopupFromDemoAccount, getImportInfoByApiCommon, addImportInfoToSyncList,validateLogin } from '../../Common/Appcommon';
import requestApiService from '../../services/requestApi.service';
import Loading from '../../Common/Loading';
import NoRecordFound from '../Common/NoRecordFound';
import Select from "react-select";
import { providersSelectList,providers } from './assets/css/constants';
import { subaccountAddedMessage } from './constants'; 
import TooltipItem from '../../Common/ToolTip';
import { decode as base64_decode } from 'base-64';
import CustomListTable from '../../Common/CustomListTable';
import { AppContext } from '../../Context/AppContext';

class SubAccounts extends React.Component { 
    static contextType = AppContext; 
    constructor(props) {
        super(props);
        let accDetails = props?.match?.params?.param !== undefined && props?.match?.params?.param !== null && props?.match?.params?.param !== "" ? true : false;
        setSessionValue("onBoardingReload" , "false");
        setSessionValue("onBoardingStatus", accDetails ? "true" : "false");
        this.state = {
            selectedValue:null,
            data: [],
            columns: [],
            showDetailed: false,
            accountInfo: {},
            isModalOpen: false,
            subAccountName: '',
            errorMessage: {},
            showLoader: false,
            showButtonLoading: false,
            searchStr: '',
            options: [
                {value: 'all_account', label: 'All Account'},
                { value: 'status,Active', label: 'Active' },
                { value: 'status,Deactive', label: 'In Active' },
                { value: 'type,Trial', label: 'Trial' }
            ],
            isAdmin:false,
            selectProviderList : {},
            providerName : providersSelectList[0].value,
            providers:providers,
            showAPI : false,
            providerFields:[],
            providerData:{concurrency_limit:8},
            limitReached:false,
            subAccountModalOpen : false,
            syncAllAgent : false,
            currentAgents: [], 
            selecteSyncAgents: [], 
            selectAgentList: [],
            getAgent : true,
            syncAllAgentShowLoading : false,
            curStep:1,
            subAccData: {
                trial_days: 7,
                trial_mins: 30
            },
            syncAllKB : false,
            selectKBList : [],
            selecteSyncKB : [],
            currentKB :[],
            getKB : true,
            syncAllKBShowLoading : false,
            onBoarding: props.onBoarding ?? false,
            showFirstAccount: accDetails,
            dbCreated :false,
            hideAllSyncAgent:false,
            hideAllSyncKB:false,
            btnCancel:false,
            totalRecordsCount:0,
            listTableCurPage:1,
            offset :0,
            recordsPerPage :10,
            agentSubAccCount: [],
            isMobile: isMobile()
        }
    }

    setShowLoaderStatus = async (status = false) => {
        this.setState({
            showLoader: status
        })
    }

    componentDidMount = async () => {
        setTimeout(() => {
            const onBoardingReload = getSessionValue("onBoardingReload") === "true";
            const onBoardingStatus = getSessionValue("onBoardingStatus") === "true";
            if (!onBoardingReload ){
                if(onBoardingStatus) {
                    if (isPageReload()) {
                        setSessionValue("onBoardingReload" , "true");
                        setSessionValue("onBoardingStatus", "false");
                        window.location.hash = "#/clients";
                    }
                }
            }
            if(isPageReload()){
                let subAccountDetails =  getSessionValue("subAccountDetails");
                let showAccountDetailed =   getSessionValue("showAccountDetailed") === "true";
                if(showAccountDetailed){
                    subAccountDetails = JSON.parse(subAccountDetails);
                    this.onViewAccountSettings(subAccountDetails);
                }
            }
        }, 100);

        this.setState({selectedValue:this.state.options[0]})
        await this.setShowLoaderStatus(true);
        await this.loadSubAccountData();
        await this.setShowLoaderStatus();
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.state.onBoarding && this.props.currentStep !== prevProps.currentStep) {
            this.setState({
                curStep: this.props.currentStep
            });
        }
        if (this.state.syncAllAgent && !prevState.syncAllAgent) {
            this.fetchProviderData("agent");
        }
    
        if (this.state.syncAllKB && !prevState.syncAllKB) {
            this.fetchProviderData("knowledge");
        }

        if (this.state.curStep === 2 && prevState.curStep !== 2) {
            this.handleApiMappingCheck();
        }
    }

    handleApiMappingCheck = async () => {
        let {providerData,providerName,subAccData} = this.state;
        let appid = subAccData.appid;
        let proData = getEncodeData(providerData, appid);
        let resA = await isApiAlreadyMapped(providerName, proData, appid, 'Agent', 'spec');
        let resKb = await isApiAlreadyMapped(providerName, proData, appid, 'Knowledge', 'spec');
        this.setState({hideAllSyncAgent:!resA,hideAllSyncKB:!resKb});
    };

    fetchProviderData = async (name) => {
        let { providerName, providerData, subAccData } = this.state;
        let appid = subAccData.appid;
        providerData = getEncodeData(providerData, appid);
        this.setState({showButtonLoading : true});
        try {
            if(name === "agent"){
                let Agentresponse = await getImportInfoByApiCommon(providerName,name, providerData,appid);
                if(Agentresponse.issuccess){
                    let Agentdata = Agentresponse.data[0];
                    this.setState({selecteSyncAgents:Agentdata});
                }
            }else if(name === "knowledge"){
                let KBresponse = await getImportInfoByApiCommon(providerName,name, providerData,appid);
                if(KBresponse.issuccess){
                    let KBdata = KBresponse.data[0];
                    this.setState({selecteSyncKB:KBdata});
                }
            }
        } catch (error) {
            console.error("Error fetching provider data:", error);
        }
        this.setState({showButtonLoading : false});
    }
    
    onViewAccountAction = (row) => {
        let { data_row } = row;
        let appid = data_row.appid;
        setSessionValue("isSubAccountView", true);
        setSessionValue("subAccountAppid", appid);
        window.location = "#/login_check";
    }

    onViewAccountSettings = (row) => {
        this.setState({
            accountInfo: row,
            showDetailed: true
        })
        setSessionValue("subAccountDetails", JSON.stringify(row));
        setSessionValue("showAccountDetailed", true);
    }

    loadSubAccountData = async (searchValue,pageLimit = 10,pageOffset = 0) => {
        let agentId = getOrganizationInfo("Account_ID");
        let { selectedValue } = this.state;
        if (agentId !== "" && agentId !== undefined) {
            let params = {
                "ENTITY": "AIPROCESSOR",
                "OPERATION": "LOAD_SUBACCOUNTS",
                "AGENT_ID": agentId,
                "SearchStr": searchValue,
                "filter":selectedValue,
                'LIMIT' : pageLimit,
                'OFFSET' : pageOffset
            }
            let formresponse = await requestApiService.processServerRequest(params, "WebV2");
            if (formresponse.issuccess) {
                let data = formresponse.data;
                let subaccounts = data[0] ?? [];
                let columndetails = data[1] ?? [];
                let subCount = data[2] ?? 0;
                let subaccountData = await getSubaccountCount();
                let maxLimitReached = false;
                let balance_days = getSessionValue("balance_days");
                let customer_type = getSessionValue("customer_type");
                if(customer_type === "Trial"){
                    if(balance_days !== "UL" && balance_days <= 0){
                        maxLimitReached =  true;
                    }
                }else if(subaccountData[0] >= subaccountData[1]){
                    maxLimitReached =  true;
                }
                this.setState({
                    limitReached: maxLimitReached,
                    totalRecordsCount: subCount,
                    agentSubAccCount: subaccountData
                });
                await this.preparesubAccountData(subaccounts, columndetails);
            }
        }
    }

    /*loadSubAccountData = async () => {
        let formDetail = await populateFormDetails("table_201");
        let { selectedTemplate } = await getTemplatesFormDetails(formDetail);
        let SubAccountsData = await loadFormData("table_201", formDetail, selectedTemplate);
        if (SubAccountsData.issuccess) {
            let { formData, listFields } = SubAccountsData;
            this.preparesubAccountData(formData, listFields);
        }
    }*/
        onAddMoreVariants = (variationCount, name) => {
            const listKey = name === "agent" ? "selectAgentList" : "selectKBList";
            const newList = [...this.state[listKey]];
        
            for (let vi = 0; vi < variationCount; vi++) {
                newList.push({ value: null });
            }
            this.setState({ [listKey]: newList });
        };
        

    handleAgentChange = async (selectedOption, index) => {
        const { selectAgentList, currentAgents ,selecteSyncAgents } = this.state;
        const [updatedList, updatedSyncAgents, updatedAgents]  = await handelCommonChangeAgent(selectedOption, index,selectAgentList, currentAgents ,selecteSyncAgents)
        this.setState({
            selectAgentList: updatedList,
            selecteSyncAgents: updatedSyncAgents,
            currentAgents: updatedAgents,
        });
    };

    removeVariant = async (index) => {
        const { selectAgentList, currentAgents } = this.state;
        const [updatedList, updatedSyncAgents, updatedCurrentAgents] = await handleCommonRemoveAgent(index, selectAgentList, currentAgents);
        this.setState({ 
            selectAgentList: updatedList,
            selecteSyncAgents: updatedSyncAgents,
            currentAgents:updatedCurrentAgents,
        });
    };

    handleKBChange = async(selectedOption,index) => {
        const { selectKBList, currentKB ,selecteSyncKB } = this.state;
        const [updatedList, updatedSyncKB, updatedKB]  = await handelCommonChangeAgent(selectedOption, index,selectKBList, currentKB ,selecteSyncKB)
        this.setState({
            selectKBList: updatedList,
            selecteSyncKB: updatedSyncKB,
            currentKB: updatedKB,
        });
    }

    removeKBVariant = async (index) => {
        const { selectKBList, currentKB } = this.state;
        const [updatedList, updatedSyncKB, updatedCurrentKB] = await handleCommonRemoveAgent(index, selectKBList, currentKB);
        this.setState({ 
            selectKBList: updatedList,
            selecteSyncKB: updatedSyncKB,
            currentKB: updatedCurrentKB,
        });
    };

    onClickgGetDetails = async (Modelname) =>{
        let { providerData, providerName } = this.state;
        let errorMessage = "";
        let name = "";
        if (providerData[providerName+"_api_key"] === undefined || providerData[providerName+"_api_key"] === null || providerData[providerName+"_api_key"].trim() === "") {
            errorMessage = "Enter your API key to sync agents.";
            if(Modelname === 'agent'){
                name = "AgentSelect"
            }else{
                name = "kbSelect"
            }
        }
        if((providerName === "vapi") && (providerData[providerName+"_pub_key"] === undefined || providerData[providerName+"_pub_key"] === null || providerData[providerName+"_pub_key"] === "")){
            errorMessage = "Enter your API key to sync agents.";
            if(Modelname === 'agent'){
                name = "AgentSelect"
            }else{
                name = "kbSelect"
            }
        }
        if(errorMessage !== ""){
            this.setState(prevState => ({
                errorMessage: {
                    ...prevState.errorMessage,
                    [name]: errorMessage,
                }
            }));
            return;
        }
        providerData = getEncodeData(providerData,"");
        if(Modelname === 'agent'){
            await this.getAgentByApi(providerName,providerData);
        }else if(Modelname === 'knowledge'){
            await this.getKBByApi(providerName,providerData);
        }
    }

    getAgentByApi = async (providerName,providerData) =>{
        this.setState({syncAllAgentShowLoading:true});
        let response = await getImportInfoByApiCommon(providerName,"agent",providerData);
        if(response.issuccess){
            let data = response.data[0];
            if(data && data.length > 0){
                this.onAddMoreVariants(1,"agent");
            }
            this.setState({currentAgents : data , errorMessage: {apiError: ""},getAgent:false,selecteSyncAgents:[]});
        }else{
            let message = response.errormsg ?? "";
            if(message === ""){
                message = translateContent("vm.get.api.sync.failed",{label:'Agent'});
            }
            showToast(message, "top-right", "error");
        }
        this.setState({syncAllAgentShowLoading:false})
    }

    getKBByApi = async (providerName,providerData) =>{
        this.setState({syncAllKBShowLoading:true});
        let response = await getImportInfoByApiCommon(providerName,"knowledge",providerData);
        if(response.issuccess){
            let data = response.data[0];
            if(data && data.length > 0){
                this.onAddMoreVariants(1,"knowledge");
            }
            this.setState({currentKB : data , errorMessage: {apiError: ""},getKB:false,selecteSyncKB:[]});
        }else{
            let message = response.errormsg ?? "";
            if(message === ""){
                message = translateContent("vm.get.api.sync.failed",{label:'Knowledge Base'});
            }
            showToast(message, "top-right", "error");
        }
        this.setState({syncAllKBShowLoading:false})
    }
    
    handelRadioBtnChange = async (All,name) =>{
        if(name === 'agent'){
            this.setState({syncAllAgent:All,currentAgents:[],selectAgentList:[],selecteSyncAgents:[],getAgent:true,errorMessage:''});
        }else if(name === 'knowledge'){
            this.setState({syncAllKB:All,currentKB:[],selectKBList:[],selecteSyncKB:[],getKB:true,errorMessage:''});
        }
    }
    
    preparesubAccountData = async (formData, listFields) => {
        let data = [];
        let columns = [];
        let isAdmin = await checkIsAdmin();
        this.setState({isAdmin:isAdmin});
        let tableData = await prepareCustomTableData(formData, listFields, isAdmin ? true : false, false, this.onViewAccountSettings);
        let account_id = getSessionValue("showAccount_Id"); 
        data = tableData.data;
        data = data.map((fd, index) => {
            fd["view_as_agency"] = 'Access';
            fd["account_settings"] = 'Manage';
            return fd;
        });
        columns = tableData.columns;

        isAdmin && !this.state.limitReached && columns.push(
             {
                name: "Action",
                selector: 'access',
                minWidth: '105px !important',
                cell: (row) => (
                    <div>
                        <Button onClick={() => this.onViewAccountAction(row)} className="access-account-btn theme-bg-g">
                            <span>{row['view_as_agency']}</span>
                            <i class="ml-2 fi fi-bs-arrow-up-right-from-square"></i>
                        </Button>
                    </div>
                ),
                style: {
                    padding: 0,
                    margin: 0,
                    justifyContent: 'center'
                }
            },
        );
        
        this.setState({
            data, columns
        });
        if(this.state.showFirstAccount){
            this.onViewAccountSettings(data[0]);
            this.toggle();
        }
        if(account_id !== ""){
            const filteredAccount = this.state.data.find(account =>
                account.data_row?.account_id === account_id
            );
            this.onViewAccountSettings(filteredAccount);
            setSessionValue("showAccount_Id","");
        }

    }

    handleProviderChange = async (option) => {    
        const selectedProvider = providers.find(provider => provider.name === option.value);
        const providerFields = selectedProvider ? selectedProvider.fields : [];
        let concurrency_limit = 8;
        if(option.value === "bland" || option.value === "vapi"){
            concurrency_limit = 8;
        }else if(option.value === "retell"){
            concurrency_limit = 16;
        }
        this.setState({
            selectProviderList: option,
            providerName: option.value,
            showAPI: true,
            providerFields:providerFields,
            providerData:{concurrency_limit:concurrency_limit}
        });    
    };
    onProviderInputChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            providerData: {
                ...prevState.providerData,
                [name]: value.trim(),
            },
        }));
    };
    

    handleTrialInputChange = (e) =>{
        let name = e.target.name;
        let value = e.target.value;
        if(isNaN(value)){
            return;
        }else if(value === ""){
            value = 0;
        }else{
            value = parseInt(value);
        }
        this.setState(prevState => ({
            subAccData: {
                ...prevState.subAccData,
                [name]: value,
            }
        }));
    }
      
      
    
    getModalContent = () => {
        let { isModalOpen, showButtonLoading,curStep,btnCancel } = this.state;
        return (
            <>
                <Modal isOpen={isModalOpen} className={'client-modal-widget'}>
                    <ModalHeader> {/* toggle={curStep === 1 ? this.closeModal : false} */}
                        <label className={`client-modal`}>{curStep === 1 ? 'Add New Client' : (curStep === 2 ? 'Sync Resources' : 'Trial Settings')}</label>
                    </ModalHeader>
                    <ModalBody>
                        {this.getSubAccountSteps(curStep)}
                    </ModalBody>
                    <ModalFooter className='d-flex justify-center'>
                        <>{!btnCancel && (<Fragment>
                            <Button className='container-footer-save d-flex flex-center align-center custom-btn-1 m-0 cancel-shadow' onClick={e => {this.closeModal(e,true)}}>
                                {'Cancel '}
                            </Button>
                        </Fragment>)}</>
                        <Loading showLoader={showButtonLoading} mainContent={
                            <Fragment><Button className='container-footer-save d-flex flex-center align-center theme-bg-g' onClick={e => { this.addsubAccount(e) }}>
                                {curStep === 3 ? 'Complete' : 'Save & Next'}
                            </Button>
                            </Fragment>
                        } />
                    </ModalFooter>
                </Modal>
            </>
        );
    }


    getSubAccountSteps = (curStep) =>{
        let { errorMessage,providerName,showAPI,providerFields,syncAllAgent,currentAgents,selectAgentList,syncAllAgentShowLoading,getAgent,syncAllKB,subAccData,selectKBList,currentKB,getKB,syncAllKBShowLoading,onBoarding,hideAllSyncAgent,hideAllSyncKB } = this.state;
        return(
            <Fragment>
                <div className={`client-modal`}>
                    <div className={`step ${curStep === 1 ? 'active' : ''}`}>
                        <Fragment>
                            <Label className='field-container-title'>Name</Label>
                                <Input className="mb-2" onChange={e => { this.handleInputChange(e) }} maxLength={100} required value={this.state.subAccountName}></Input>
                                <div>                            
                                    {errorMessage['subName'] !== "" && <em className="error">{errorMessage['subName']}</em>}
                                </div>
                            <Label className='field-container-title'>Choose Provider</Label>
                                <div className=''>
                                    <Select
                                        isClearable={false}
                                        onChange={e => this.handleProviderChange(e)}
                                        placeholder={"Choose a ai name"}
                                        options={providersSelectList}
                                        value={this.state.selectProviderList}
                                        className='basic-multi-select p-0'
                                        classNamePrefix="wa-select"
                                        isSearchable={false}
                                    />
                                </div>
                                
                                {showAPI &&
                                    <div className='mt-4'>
                                        <Label className='field-container-title mb-0'>Connect API</Label>
                                        <div className='field-details'>
                                            {
                                                <>
                                                <Row key={providerName}>
                                                    {providerFields.map((field) => {
                                                        const { name, label, type } = field;
                                                        let fname = providerName + "_" + name;
                                                        return (
                                                            <Col key={fname} md={12} className={'pt-1'}>
                                                                <label className={'form-label'} htmlFor={fname}>{label}</label>
                                                                <input
                                                                    onChange={(e) => {this.onProviderInputChange(e);}}
                                                                    type={type}
                                                                    name={fname}
                                                                    id={fname}
                                                                    autoComplete={"off"}
                                                                    className={`form-control`}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === " ") {
                                                                            e.preventDefault();
                                                                        }
                                                                    }}
                                                                />
                                                            </Col>
                                                        );
                                                    })}
                                                </Row>
                                             </>
                                            }
                                        </div>
                                        {showAPI && curStep === 1 && !onBoarding &&
                                <div className=''>
                                    <p className='mt-1'>Need help? <a href='https://docs.voicemetrics.ai/faq/voiceprovider' target='_blank' rel="noreferrer"  className='provider-url-btn'><span className='text-d-underline'>Click here</span></a> to learn how to generate your API key on AI Voice platforms.</p>
                                </div>
                                }
                                    </div>
                                    
                                }
                            <div className='mt-2'>
                                {errorMessage['apiError'] && <em className="error">{errorMessage['apiError']}</em>}
                            </div>
                            <div className='mt-2'>
                                {errorMessage['ApiMappingError'] && <em className="error">{errorMessage['ApiMappingError']}</em>}
                            </div>
                            {showAPI && curStep === 1 && onBoarding &&
                                <div className=''>
                                    <p className='mt-1 mb-0'>Need help? <a href='https://docs.voicemetrics.ai/faq/voiceprovider' rel="noreferrer" target='_blank' className='provider-url-btn'><span className='text-d-underline'>Click here</span></a> to learn how to generate your API key on AI Voice platforms.</p>
                                </div>
                            }
                        </Fragment>
                    </div>
                    <div className={`step ${curStep === 2 ? 'active' : ''}`}>
                        <Fragment>
                        { 
                        <>       
                        <div className='mt-2'>       
                            <label className='provider-header'>Choose Agents</label>             
                            <div className="mt-2">
                                    <Label className="me-2">
                                        <Input
                                            type="radio"
                                            name="syncSpecificAgent"
                                            checked={syncAllAgent === false}
                                            onChange={() => this.handelRadioBtnChange(false,'agent')}
                                        />
                                        <span className="ml-2">
                                            Sync specific agents only
                                        </span>
                                    </Label>
                                    <Label className="me-2">
                                        <Input
                                            type="radio"
                                            name="syncAllAgent"
                                            checked={syncAllAgent === true}
                                            disabled={hideAllSyncAgent}
                                            onChange={() => this.handelRadioBtnChange(true,'agent')}
                                        />
                                        <span className={`ml-2 ${hideAllSyncAgent && 'disable-radio-btn'}`}>
                                            Sync all agents    
                                        </span>
                                        <span className='ms-1'>
                                            {hideAllSyncAgent && (<TooltipItem id={"agent"} text={"Cannot sync all agents because the API is already synced with another account with specific configuration."} content={<i class="fi fi-ss-info"></i>} />)}
                                        </span>
                                    </Label>
                                </div>
                            </div>
                        </>
                        }
                        { 
                            !syncAllAgent && (
                                <>
                                    <div className={'d-flex justify-content-start mb-2'}> {getAgent && (<Button className='theme-bg-g' onClick={() => this.onClickgGetDetails('agent')}>Get Agent</Button>)} </div>
                                    <Loading
                                        mainContent={
                                            <>
                                                {
                                                    <div>               
                                                        {renderSelectableList(
                                                            selectAgentList,
                                                            currentAgents,
                                                            this.handleAgentChange,
                                                            this.removeVariant,
                                                            this.onAddMoreVariants,
                                                            'agent'
                                                        )}
                                                        <div>
                                                            {errorMessage['AgentSelect'] && <em className="error">{errorMessage['AgentSelect']}</em>}
                                                        </div>
                                                    </div>
                                                }
                                                { currentAgents.length === 0 && selectAgentList.length === 0 &&  !getAgent && (
                                                    <>
                                                        <div className='invalid-feedback'>
                                                            No Agent is available
                                                        </div>
                                                    </>                          
                                                )}

                                            </>
                                        }
                                        showLoader={syncAllAgentShowLoading}
                                    />
                                </>
                            )
                        }
                        
                        {providerName !== 'bland' && (
                            <>
                                <label className="provider-header mt-4">Choose Knowledge Base</label>
                                <div className="mt-2">
                                    <Label className="me-2">
                                        <Input
                                            type="radio"
                                            name="knowledgeSync"
                                            checked={!syncAllKB}
                                            onChange={() => this.handelRadioBtnChange(false, 'knowledge')}
                                        />
                                        <span className="ml-2">Sync Specific Knowledge Base only</span>
                                    </Label>
                                    <Label className="me-2">
                                        <Input
                                            type="radio"
                                            name="knowledgeSync"
                                            checked={syncAllKB}
                                            disabled={hideAllSyncKB}
                                            onChange={() => this.handelRadioBtnChange(true, 'knowledge')}
                                        />
                                        <span className={`ml-2 ${hideAllSyncKB && 'disable-radio-btn'}`}>Sync All Knowledge Base</span>
                                        <span className='ms-1'>
                                            {hideAllSyncKB && (<TooltipItem id={"kb"} text={"Cannot sync all knowledge base because the API is already synced with another account with specific configuration."} content={<i class="fi fi-ss-info"></i>} />)}
                                        </span>
                                    </Label>
                                </div>

                                {!syncAllKB && (
                                    <>
                                        <div className="d-flex justify-content-start mb-2">
                                        {getKB && (
                                            <Button className="theme-bg-g" onClick={() => this.onClickgGetDetails('knowledge')}>
                                                Get Knowledge Base
                                            </Button>
                                        )}
                                        </div>

                                        <Loading
                                        mainContent={
                                            <>
                                            <div>
                                                {renderSelectableList(
                                                    selectKBList,
                                                    currentKB,
                                                    this.handleKBChange,
                                                    this.removeKBVariant,
                                                    this.onAddMoreVariants,
                                                    'knowledge'
                                                )}
                                                {errorMessage['kbSelect'] && (
                                                <div>
                                                    <em className="error">{errorMessage['kbSelect']}</em>
                                                </div>
                                                )}
                                                { currentKB.length === 0 && selectKBList.length === 0 &&  !getKB && (
                                                    <>
                                                        <div className='invalid-feedback'>
                                                            No Knowledge Base is available
                                                        </div>
                                                    </>                          
                                                )}
                                            </div>
                                            </>
                                        }
                                        showLoader={syncAllKBShowLoading}
                                        />
                                    </>
                                )}

                                {providerName === 'vapi' && (
                                <div className="kb-bg mt-2">
                                    <strong>Note:</strong><br />
                                    The knowledge base integration works only if your Vapi assistant uses simple files uploaded in the "Files" section. If it uses query tools or third-party sources like Trieve, the integration won't be compatible.
                                </div>
                                )}
                            </>
                        )}

                        </Fragment>
                    </div>
                    {subAccData && <div className={`step ${curStep === 3 ? 'active' : ''}`}>
                        <Fragment>
                        { 
                            <>       
                            <div className = "">
                                <span className='heading'>Trial Days</span>
                                <p className='m-0'>Set the duration of the trial period for your client.</p>
                                <div className='pt-2 '>
                                    <InputGroup>
                                        <input
                                            name='trial_days'
                                            type="text"
                                            value={subAccData['trial_days'] ?? 7}
                                            onChange={e => {this.handleTrialInputChange(e)}}
                                            className="form-control"
                                            autoComplete={"off"}
                                            maxLength={5}
                                        />
                                        <Button disabled={true} className='trial-client-btn'>
                                            {'Days'}
                                        </Button>
                                    </InputGroup>
                                    {errorMessage['daysError'] && <em className="error">{errorMessage['daysError']}</em>}
                                </div>
                            </div>
                            <div className = "pt-2">
                                <span className='heading'>Trial Minutes</span>
                                <p className='m-0'>Set the total minutes available for calls during the trial. Default: 30 minutes</p>
                                <div className='pt-2'>
                                    <InputGroup>
                                        <input
                                            name='trial_mins'
                                            type="text"
                                            value={subAccData['trial_mins'] ?? 30}
                                            onChange={e => {this.handleTrialInputChange(e)}}
                                            className="form-control"
                                            autoComplete={"off"}
                                            maxLength={10}
                                        />                                            
                                        <Button disabled={true} className="trial-client-btn">
                                            {'Minutes'}
                                        </Button>
                                    </InputGroup>
                                    {errorMessage['minError'] && <em className="error">{errorMessage['minError']}</em>}
                                </div>
                            </div>
                            </>
                        }
                        </Fragment>
                    </div>}
                </div>
            </Fragment>
        )
    }

    handleInputChange = (e) => {
        let value = e.target.value;
        const regex = /^[a-zA-Z0-9 _-]*$/;
        if (regex.test(value)) {
            this.setState(prevState => ({
                subAccountName: value,
                errorMessage: {
                    ...prevState.errorMessage, // Keep existing errors
                    subName: (value !== undefined && value !== "") ? '' : prevState.errorMessage.subName
                }
            }));
        } else {
            this.setState(prevState => ({
                errorMessage: {
                    ...prevState.errorMessage, // Keep existing errors
                    subName: "Special characters are not allowed." // Add/update the error for subName
                }
            }));
        }
    }

    addsubAccount = async (e) => {
        e.preventDefault();
        let { subAccountName,showAPI,providerData,providerName,curStep,subAccData,dbCreated ,onBoarding} = this.state;
        let errorMessage = "";
        let name = "";
        let moveToNextStep = true;
        if(!showAPI){
            errorMessage = "Please first select your provider.";
            name = "apiError"
        }
        providerData['create_contact_allowed'] = true;
        if(showAPI){
            if (providerData[providerName+"_api_key"] === undefined || providerData[providerName+"_api_key"] === null || providerData[providerName+"_api_key"].trim() === "") {
                errorMessage = "Key value is required.";
                name = "apiError"
            }
            if((providerName === "vapi") && (providerData[providerName+"_pub_key"] === undefined || providerData[providerName+"_pub_key"] === null || providerData[providerName+"_pub_key"] === "")){
                errorMessage = "Key value is required.";
                name = "apiError"
            }
        }

        if(curStep === 3){
            let errorMessage = {};
            const trialDays = parseInt(subAccData.trial_days, 10);
            if (isNaN(trialDays)) {
                errorMessage['daysError'] = 'Please provide Trial Days';
            } else if (trialDays < 1) {
                errorMessage['daysError'] = 'Please provide Days > 1';
            } else {
                errorMessage['daysError'] = '';
            }

            const trialMins = parseInt(subAccData['trial_mins'], 10);
            if (isNaN(trialMins)) {
                errorMessage['minError'] = 'Please provide Trial Minutes';
            } else if (trialMins < 1) {
                errorMessage['minError'] = 'Please provide Trial Minutes > 1';
            } else {
                errorMessage['minError'] = '';
            }

            if (errorMessage['daysError'] || errorMessage['minError']) {
                this.setState(prevState => ({
                    errorMessage: {
                        ...prevState.errorMessage,
                        ...errorMessage
                    }
                }));
                return;
            } else {
                this.setState({
                    errorMessage: {}
                });
            }
       
        }
        if(curStep === 1){
            if (subAccountName.trim() === "" || subAccountName === undefined) {
                errorMessage = "Please enter a name.";
                name = 'subName';
                this.setState(prevState => ({
                    errorMessage: {
                        ...prevState.errorMessage, // Keep existing errors
                        subName: "Please enter a name." // Set the specific error
                    }
                }));
            }
        }
        
        if(errorMessage !== ""){
            this.setState(prevState => ({
                errorMessage: {
                    ...prevState.errorMessage, // Keep existing errors
                    [name]: errorMessage // Set the specific error
                }
            }));
        } else {
            await this.setShowLoaderStatus(true);
            this.setState({
                errorMessage: {},
                showButtonLoading: true,
                btnCancel:true
            })
            let account_id = "";
            if(curStep === 1){
                if(!dbCreated){
                    let proData = getEncodeData(providerData,"");
                    let checkApi = await isApiKeyValid(providerName,proData,"");
                    if(!checkApi){
                        errorMessage =  translateContent("vm.subaccount.provider.error.msg");
                        this.setState(prevState => ({
                            errorMessage: {
                                ...prevState.errorMessage,
                                apiError: errorMessage,
                            },
                            showLoader:false,
                            showButtonLoading:false,
                            btnCancel:false
                        })); 
                        return;
                    }
                    let resA = await isApiAlreadyMapped(providerName,proData,"",'Agent','ALL');
                    if(!resA){
                        this.setState(prevState => ({
                            errorMessage: {
                                ...prevState.errorMessage,
                                ApiMappingError: "API Key is already mapped to another account.",
                            },
                            showLoader:false,
                            showButtonLoading:false,
                            btnCancel:false
                        }));
                        return;
                    }
                    let params = {
                        "ENTITY": "AIPROCESSOR",
                        "OPERATION": "ADD_SUBACCOUNT",
                        "accountname": subAccountName,
                        "isAgencyInvite": true,
                        "agency_id": getOrganizationInfo("Account_ID"),
                        "agency_appid": getSessionValue('appid'),
                    }
                    let error = false;
                    let formresponse = await requestApiService.processServerRequest(params, "WebV2",'post', false ,300000);
                    if (formresponse.issuccess) {
                        let data = formresponse.data !== undefined && formresponse.data !== null && formresponse.data !== "" ? formresponse.data[0] : "";
                        if(data !== undefined && data !== null &&data !== ""){
                            if(data?.issuccess !== undefined && data?.issuccess !== null && data?.issuccess){
                                this.setState(prevState => ({
                                    subAccData: {
                                        ...prevState.subAccData,
                                        ...data
                                    },
                                    dbCreated:true
                                }));
                            }else{
                                error = true;
                            }
                        }
                        if(!onBoarding){
                            setSessionValue('menus', JSON.stringify(formresponse.data[1]));
                        }
                    } else {
                        error = true
                    }
                    if(error){
                        this.setState({
                            showButtonLoading: false,
                        });
                        this.setState(prevState => ({
                            errorMessage: {
                                ...prevState.errorMessage,
                                apiError: "Unable to create sub account.",
                            }
                        })); 
                        moveToNextStep = false;
                        return;
                    }
                }else{
                    let formData ={
                        "account_name" : subAccountName,
                        "subAppid" : this.state.subAccData.appid,
                    }
                    let params = {
                        "ENTITY": "AIPROCESSOR",
                        "OPERATION": "UPDATE_SUBACCOUNT_DETAILS",
                        "FORMDATA":formData,
                    }
                    let formresponse = await requestApiService.processServerRequest(params, "WebV2");
                    if(!formresponse.issuccess){
                        this.setState(prevState => ({
                            errorMessage: {
                                ...prevState.errorMessage,
                                subName:"Unable to update the account name."
                            },
                        }));
                        moveToNextStep = false;
                    }
                }
                let appid = this.state.subAccData.appid;
                let account_id = this.state.subAccData.account_id;
                let providerEncodeData = getEncodeData(providerData,appid);
                let response = await this.saveapiDetails(providerEncodeData,providerName,account_id,appid,false);
                if(!response.issuccess){
                    moveToNextStep = false;
                    this.setState({
                        showButtonLoading: false,
                    });
                    let isValid =  response?.data?.[0]?.[0] !==  undefined ? response.data[0][0] : false;
                    let errorMessage = translateContent("vm.subaccount.sync.failed");
                    // handleErrorResponse(translateContent("vm.subaccount.sync.failed"));
                    this.setState(prevState => ({
                        errorMessage: {
                            ...prevState.errorMessage,
                            apiError: errorMessage,
                        }
                    }));
                    if(!isValid){
                        errorMessage =  translateContent("vm.subaccount.provider.error.msg");
                        this.setState(prevState => ({
                            errorMessage: {
                                ...prevState.errorMessage,
                                apiError: errorMessage,
                            }
                        })); 
                    }
                }
            }
            /* curStep === 1 || */
            if(curStep === 2){
                moveToNextStep  = await this.syncAgentDetails();
            }
            if(curStep === 3){
                account_id = subAccData.account_id;
                this.setState({
                    showButtonLoading: true,
                });
                let params = {
                    'ENTITY': 'AIPROCESSOR',
                    'OPERATION': 'UPDATE_VM_LICENSE',
                    'subAccData': subAccData,
                };
                let response = await requestApiService.processServerRequest(params);
                if(response.issuccess){
                    // showToast(translateContent("vm.subaccount.license.success"));
                }
                this.setState({
                    showButtonLoading: false
                });
                setTimeout(async() => {
                    //window.location.reload();
                    await this.loadSubAccountData();
                    if (account_id !== "") {
                        const filteredAccount = this.state.data.find(account =>
                            account.data_row?.account_id === account_id
                        );
                        const useThemeFunc = this.context;
                        await validateLogin("", false,useThemeFunc);
                        this.toggle();
                        this.onViewAccountSettings(filteredAccount);
                    }
                }, 500);
            }
            if(moveToNextStep){
                if(curStep === 3 ){
                    if(onBoarding && typeof this.props.getRedirectData === 'function'){
                        this.props.getRedirectData(subAccData)
                    }
                }
                if (onBoarding && typeof this.props.handleNextStep === 'function') {
                    this.props.handleNextStep();
                }
    
                if(curStep !== 3){
                    let skipNum = 1;
                    if(curStep == 1){
                        skipNum = 2
                    }
                    this.setState(prevState => ({
                        curStep: curStep + skipNum,
                        showButtonLoading: false,
                    }));                            
                    return;
                }else{
                    this.closeModal();
                    this.setState({curStep:1,btnCancel:false,subAccData: {
                        trial_days: 7,
                        trial_mins: 30
                    }});
                    
    
                }
            }
            this.setState({
                showButtonLoading: false,
            });    
            await this.setShowLoaderStatus();
        }
    }

    saveapiDetails = async(providerData,providerName,account_id,appid , sync = true) =>{
        let params = {
            'ENTITY': 'AIPROCESSOR',
            'OPERATION': 'SAVE_API_DETAILS',
            'PROVIDER_DATA': providerData,
            'PROVIDER': providerName,
            'ACCOUNT_ID': account_id,
            "SUBACCOUNTID": appid,
            'isSync' : sync,
        };
        let response = await requestApiService.processServerRequest(params);
        return response;
    }

    syncAgentDetails = async() =>{
        let {providerData,providerName,selecteSyncAgents,syncAllAgent,subAccData,syncAllKB,selecteSyncKB } = this.state;
        let appid = subAccData.appid;
        providerData = getEncodeData(providerData,appid);
        let account_id = subAccData.account_id;
        let issuccess = true;
        let errorMessage = "";
        let Agentresponse = await addImportInfoToSyncList(appid,selecteSyncAgents,providerName,providerData,syncAllAgent,"agent")
        if(!Agentresponse.issuccess){
            issuccess = false
            errorMessage = translateContent("vm.save.api.sync.failed", {label:'agent'});
            this.setState(prevState => ({
                errorMessage: {
                    ...prevState.errorMessage,
                    AgentSelect: errorMessage,
                }
            }));
            // handleErrorResponse(errorMessage);
        }
        let KBresponse = await addKBToSyncList(appid,selecteSyncKB,providerName,providerData,syncAllKB)
        if(!KBresponse.issuccess){
            issuccess = false
            errorMessage = translateContent("vm.save.api.sync.failed", {label : 'knowledge base'});
            this.setState(prevState => ({
                errorMessage: {
                    ...prevState.errorMessage,
                    kbSelect: errorMessage,
                }
            }));
            // handleErrorResponse(errorMessage);
        }
        if(issuccess){
            let response = await this.saveapiDetails(providerData,providerName,account_id,appid);
            if(response.issuccess){
                if(!this.state.onBoarding){
                    showToast(translateContent("vm.subaccount.sync.success"));
                }
            }else{
                issuccess = false
                errorMessage = translateContent("vm.subaccount.sync.failed");
                this.setState(prevState => ({
                    errorMessage: {
                        ...prevState.errorMessage,
                        apiError: errorMessage,
                    }
                }));
                // handleErrorResponse(errorMessage);
            }
        }
        this.setState({
            showButtonLoading: false,
        });

        return issuccess;
    }
    handlesubAccount = async () => {
        if (getPopupFromDemoAccount()) {
            return;
        }
        let { agentSubAccCount } = this.state;
        let isBtnEnabled = false;
        if(agentSubAccCount && !!agentSubAccCount[1]){
            let cur_sub = agentSubAccCount[0];
            let max_sub = agentSubAccCount[1];
            if(max_sub === "UL" || max_sub > cur_sub){
                isBtnEnabled = true;
            }else{
                let header = "Kind Attention!";
                let body = `You've reached your client-account limit (${cur_sub}/${max_sub}). Upgrade now to add more!`;
                let confirmbtn = "Upgrade Now";
                let cancelbtn = "Cancel";
                let confirm = await confirmBoxWithImage(header, body, 'warning', confirmbtn, cancelbtn);
                if(confirm){
                    window.location.hash = "#/subscription";
                }
            }
        }else{
            // this is trial plan customers
            isBtnEnabled = true;
        }
        if(isBtnEnabled){
            this.setState((prevState) => ({
                isModalOpen: !prevState.isModalOpen,
            }));
        }
    }

    closeModal = (name,isCancel=false) => {
        let {curStep} = this.state;
        this.setState((prevState) => ({
            isModalOpen: !prevState.isModalOpen,
            errorMessage: {},
            showButtonLoading: false,
            subAccountName: '',
            selectProviderList : {},
            providerName : providersSelectList[0].value,
            providers:providers,
            showAPI : false,
            providerFields:[],
            providerData:{concurrency_limit:8}, 
            syncAllAgent : true, 
            currentAgents :[],
            selecteSyncAgents : [],
            syncAllAgentShowLoading : false,
            dbCreated:false,
        }));
        if(curStep !== 1 && isCancel){
            window.location.reload();
        }
    }

    backToViewAction = async () => {
        if(this.state.showFirstAccount){
            window.location.hash = "/clients"
        }
        this.setState({
            accountInfo: {},
            showDetailed: false
        })
        setSessionValue("showAccountDetailed", false);
        await this.loadSubAccountData();
    }

    handleChange = async (selectedOption) => {
        this.setState({ selectedValue: selectedOption }, async () => {
            await this.loadSubAccountData();
        });
    };    

    handleAccountInfoChange = (updatedInfo) => {
        this.setState({ accountInfo: updatedInfo });
    };

    getTitleBody = (showDetailed) => {
        if (showDetailed) {
            return "";
        }
        return <div className='d-flex align-center justify-end w-100'>
            {
                this.state.isMobile ? (
                    <div className='m-3 w-100'>
                        <Row md={12} className='mb-2 mt-2'>
                            <Col md={12}>
                                <div className='le-form-row'>
                                    <div className="input-with-icon">
                                        <span className="search-icon">
                                            <i class="icon-color fi fi-rs-search"></i>
                                        </span>
                                        <Input
                                            id="userName"
                                            autoComplete="off"
                                            placeholder="Search by name"
                                            onChange={(e) => {
                                                this.handleSearch(e)
                                            }}
                                            value={this.state.searchStr}
                                            className='search-input'
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row md={12} className='mb-2'>
                            <Col md={12}>
                                <Select
                                    name="selected_form"
                                    id="selected_form"
                                    placeholder="All Account"
                                    className="basic-select"
                                    classNamePrefix="sub-select wa-select"
                                    value={this.state.selectedValue} 
                                    options={this.state.options} 
                                    onChange={this.handleChange}
                                />
                            </Col>
                        </Row>
                        {
                            this.state.isAdmin &&
                            <Button onClick={e => this.handlesubAccount()} className='theme-bg-g w-100 gap-2' color="dark">
                                <FontAwesomeIcon icon={faPlus}/>
                                <>
                                    Add New Client
                                </>
                            </Button>
                        }
                    </div>
                ) : (
                    <>
                        <Col md={this.state.isAdmin && 4}  className={cx("", {
                            "hide" : isMobile()
                        })}>
                            <div className='le-form-row'>
                                <div className="input-with-icon">
                                    <span className="search-icon">
                                        <i class="icon-color fi fi-rs-search"></i>
                                    </span>
                                    <Input
                                        id="userName"
                                        autoComplete="off"
                                        placeholder="Search by name"
                                        onChange={(e) => {
                                            this.handleSearch(e)
                                        }}
                                        value={this.state.searchStr}
                                        className='search-input'
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={this.state.isAdmin && 4} className={cx("pl-2", {
                            "hide" : isMobile()
                        })}>
                            <Select
                                name="selected_form"
                                id="selected_form"
                                placeholder="All Account"
                                className="basic-select"
                                classNamePrefix="sub-select wa-select"
                                value={this.state.selectedValue} 
                                options={this.state.options} 
                                onChange={this.handleChange}
                            />
                        </Col>
                        {
                            this.state.isAdmin &&
                            <div className='pl-2'>
                                <Button onClick={e => this.handlesubAccount()} size="lg" className='theme-bg-g' color="dark"><FontAwesomeIcon icon={faPlus} /> Add New Client</Button>
                            </div>
                        }
                    </>
                )
            }
        </div>;
    }

    handleSearch = async (e) => {
        let value = e.target.value;
        this.setState({
            searchStr: value
        })
        await this.loadSubAccountData(value)
    }
    toggle = (isContinue=false) => {
        this.setState(prevState => ({ subAccountModalOpen: !prevState.subAccountModalOpen}));
        // if(isContinue){
        //     window.location.reload();
        // }
    };
    getSuccessPopup = () =>{
        let trialDays = this.state.subAccData['trial_days'];
        return (
            <Modal isOpen={this.state.subAccountModalOpen} toggle={this.toggle} size='lg'>
                <ModalBody>
                    <div className='fw-bold success-popup-header'>
                        {"🎉 You're All Set!"}
                        {/* Congrats! Your client-account has been added successfully */}
                    </div>
                    <div className='success-poup-div'>Your client account is ready. Follow these steps for more settings.</div>
                    <div className='client-popup-desc'>
                        {subaccountAddedMessage.map((message, index) => (
                            <span className='d-flex align-items-center pb-2 client-popup-desc sub-success-popup-txt'>
                                <i class="fi fi-br-check sub-add-tik"></i> <span className='ps-3'><span className='fw-bold pe-1' key={index + "_0"}>{message && message[0] ? message[0] : ""}</span>-<span className = 'ps-1' key={index + "_1"}>{message && message[1] ? message[1].replace("7", trialDays) : ""}</span></span>
                            </span>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter className='d-flex align-items-center justify-content-center'>
                    <Button className="theme-bg-g sub-success-popup-btn" onClick={() => this.toggle(true)}>
                        Continue
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }

    handleRecordChange = async (updatedOffset, page, perPageRecord) => {
        this.setState({
            listTableCurPage:page,
            offset :updatedOffset,
            recordsPerPage :perPageRecord,
        })
        await this.loadSubAccountData(this.state.searchStr,perPageRecord,updatedOffset);       
    }

    renderSubAccDetails = () =>{
        let { data, columns, showDetailed, accountInfo, isModalOpen ,subAccountModalOpen, totalRecordsCount, listTableCurPage, recordsPerPage, offset, isMobile } = this.state;
        return (
            <Fragment>
                <Common
                    title={"Clients"} 
                    titleContent={
                        <span>
                            {
                                showDetailed ? (
                                    <span className='custom-list-title'>
                                        {"Clients / "}
                                        <span className='highlight-name'>
                                            {accountInfo.account_name}
                                        </span>
                                    </span>
                                ) : (
                                    "Clients"
                                )
                            }
                        </span>
                    }
                    titleBody={!isMobile && this.getTitleBody(showDetailed)}
                    mainContent={
                        <Fragment>
                            {
                                showDetailed && (
                                    <div className='col-md-12'>
                                        <SubaccountDetails 
                                            backToViewAction={this.backToViewAction} 
                                            openSubAccountView={this.onViewAccountAction} 
                                            accountInfo={accountInfo} 
                                            limitReached={this.state.limitReached}
                                            handleAccountInfoChange={this.handleAccountInfoChange}
                                        />
                                    </div>
                                )
                            }
                            {
                                !showDetailed && (
                                    <div className={`${data.length === 0 ? 'w-100' : 'subaccount-list'}`}>
                                        <Fragment>
                                            <div className='list-view-header mt-2 w-100 mb-2 d-flex hide'>
                                                <Row className='w-100'>
                                                    <Col md={6} className='rdw-image-left'>
                                                        <div class="d-grid">
                                                            <span class="heading">{"Subaccounts"}</span>
                                                            <span class="header-desc">{""}</span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            {
                                                !!isMobile && this.getTitleBody()
                                            }
                                            {
                                                this.state.showLoader ? ( 
                                                    <Loading 
                                                        showLoader={this.state.showLoader} 
                                                        mainContent={""}
                                                    />
                                                ) : (
                                                        !this.state.showLoader ? data.length === 0 ? <NoRecordFound
                                                        img={aiData}
                                                        isOnlyContent={true}
                                                        content={"No Users Found."}
                                                    /> :
                                                            <CustomListTable
                                                                data={data}
                                                                columns={columns}
                                                                style={{}}
                                                                isAllowLoadmore = {true}
                                                                handleChange = {this.handleRecordChange}
                                                                totalRows = {totalRecordsCount}
                                                                tblCurPage = {listTableCurPage}
                                                                recordsPerPage = {recordsPerPage}
                                                                rowOptions = {getPerRecordOption()}
                                                                offSet = {offset}
                                                                isMobile = {isMobile}
                                                                selectableRows={false}
                                                            />  
                                                        : (data.length === 0 ? <NoRecordFound img={aiData} isOnlyContent={true} content={"No Users Found."}/>: <CustomListTable data={data} columns={columns} onSort={this.onSort} />)
                                                        )
                                                        // <ListTable data={data} columns={columns} onSort={this.onSort} />
                                            }
                                            {/* {
                                                !this.state.showLoader ? data.length === 0 ? <NoRecordFound
                                                img={aiData}
                                                isOnlyContent={true}
                                                content={"No Users Found."}
                                            /> :
                                                <ListTable data={data} columns={columns} onSort={this.onSort} /> : (data.length === 0 ? <NoRecordFound img={aiData} isOnlyContent={true} content={"No Users Found."}/>:<ListTable data={data} columns={columns} onSort={this.onSort} />)
                                            }  */}
                                        </Fragment>
                                    </div>
                                )
                            }
                            {
                                isModalOpen && this.getModalContent()
                            }
                            { 
                                subAccountModalOpen && this.getSuccessPopup() 
                            }
                        </Fragment>
                    } />


            </Fragment>
        )
    }

    renderOnBoardDetails = (currentStep) =>{
        let { showButtonLoading, curStep } = this.state;
        return (
            <div>
                {this.getSubAccountSteps(currentStep)}
                <div className='mt-3 d-flex justify-content-center align-items-center'>
                    <Loading showLoader={showButtonLoading} mainContent={
                        <Fragment>
                            <Button className='container-footer-save d-flex flex-center align-center theme-bg-g' onClick={e => { this.addsubAccount(e)}}>
                                {curStep === 3 ? 'Finish' : 'Save & Next'}
                            </Button>
                        </Fragment>
                    } />
                </div>
            </div>
        )
    }
    render() {
        let { onBoarding } = this.state;
        const { currentStep } = this.props;
        if(currentStep !== undefined && onBoarding){
            return(
                this.renderOnBoardDetails(currentStep)
            );
        }else{
            return (
                this.renderSubAccDetails()
            )
        }
    }
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubAccounts);
